import { Database, Json, withLogs } from '@core';
import { SupabaseClient } from '@supabase/supabase-js';
import camelcaseKeys from 'camelcase-keys';

export type Relation = {
    childDisplayOrder: number;
    childMetadata: Json | null;
    childUiNodeId: string;
    id: number;
    parentUiNodeId: string;
    showChildOn: ('kiosk' | 'floor')[] | null;
};

export const fetchRelations = withLogs(async (supabase: SupabaseClient<Database>): Promise<Relation[]> => {
    const { data, error } = await supabase.from('ui_node_relations').select('*');
    if (error) {
        console.error('error fetching public ui_component_relations:', error);
        return [];
    }

    return camelcaseKeys(data, { deep: true });
}, 'fetchRelations');
